export const handleAsyncState = (builder, action, stateKey, payloadKey = null) => {
    builder
        .addCase(action.pending, (state) => {
            state.isLoading = true
        })
        .addCase(action.fulfilled, (state, { payload }) => {
            state.isLoading = false
            if (stateKey) {
                state[stateKey] = payloadKey ? payload[payloadKey] : payload
            }
        })
        .addCase(action.rejected, (state) => {
            state.isLoading = false
        });
};